import styled from '@emotion/styled'
import { PickersTextField } from '@mui/x-date-pickers'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'

const CustomPickerTextField = styled(PickersTextField)`
	width: 150px;
	.MuiInputBase-root {
		height: 45px;
		border: 2px solid #fff;
		border-radius: 0;
	}
	.MuiOutlinedInput-notchedOutline {
		border: 0;
	}
`
const DATE_VIEWS = ['month', 'year'] as const
interface IProps {
	selectedValue: string
	onChangeHandler: (date: Date | null) => void
}
const Datepicker = (props: IProps) => {
	const { selectedValue, onChangeHandler } = props
	const dateValue = selectedValue ? new Date(selectedValue) : null
	return (
		<DatePicker
			views={DATE_VIEWS}
			format="MM/yyyy"
			value={dateValue}
			onChange={onChangeHandler}
			openTo="month"
			slots={{
				textField: CustomPickerTextField,
			}}
			slotProps={{
				textField: {
					variant: 'outlined',
				},
			}}
		/>
	)
}
export { Datepicker }
